'use client'

import { useCookieCleanup } from '@/hooks/useCookieCleanup'

/**
 * Client component that runs cookie cleanup on mount and periodically.
 *
 * This prevents HTTP 431 "Request Header Fields Too Large" errors caused by
 * cookie accumulation from multiple Supabase projects on the same domain.
 *
 * Include this component in the root layout to ensure cleanup runs app-wide.
 * It renders nothing - it's purely for the side effect of running cleanup.
 */
export function CookieCleanupProvider(): null {
    // Run cleanup on mount and every 5 minutes
    useCookieCleanup(5 * 60 * 1000)

    // This component renders nothing
    return null
}
